// extracted by mini-css-extract-plugin
module.exports = {"list":"e_tg","hero":"e_ug"};